import React, { useState } from "react"
import { Document, Page, pdfjs } from "react-pdf"

const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`
pdfjs.GlobalWorkerOptions.workerSrc = url

// Si CORS, placer le fichier mminifié dans le dossier public : https://github.com/wojtekmaj/react-pdf
// pdfjs.GlobalWorkerOptions.workerSrc = "pdf.worker.min.js"

export const PageCollection = ({ pdf }) => {
  const [numPages, setNumPages] = useState(null)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  return (
    <Document
      file={pdf}
      onLoadSuccess={onDocumentLoadSuccess}
    >
      {Array.from(new Array(numPages), (el, index) => (
        <Page renderAnnotationLayer={false} renderTextLayer={false} className="mx-auto" width={680} key={`page_${index + 1}`} pageNumber={index + 1} />
      ))}
    </Document>
  )
}
